





























































































































































































































































































































































































































































































































































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';

// services
import AppService from '@/services/app';
import CampaignService from '@/services/campaign';
import SiteUserService from '@/services/siteUser';

// models
import { Campaign } from '@/models/Campaign.model';
import { SiteUser } from '@/models/SiteUser.model';

@Component({
  components: {
    BaseMaterialCard,
  },
})
export default class CMSUserDataTable extends Vue {
  // used by Filter Area
  search: string = '';

  // used by No Data Slot
  isLoading: boolean = true;

  thisCampaign: Campaign = {
    id: 0,
    campaignName: '',
    code: 0,
    partner: '',
    survey: '',
    allocated: 0,
    used: 0,
    users: [],
  };

  clickedItem: SiteUser = {
    id: 0,
    firstName: '',
    lastName: '',
    email: '',
  };

  showResultsDialog: boolean = false;
  showSelectionsDialog: boolean = false;
  showSubjectsDialog: boolean = false;

  // #region Functions to display list data on page load
    headers() {
      return [
        {
          text: 'First Name',
          value: 'firstName',
        },
        {
          text: 'Surname',
          value: 'lastName',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'ID Number',
          value: 'idNumber',
        },
        {
          sortable: false,
          text: '',
          value: 'action',
          align: 'end',
        },
      ];
    }

    async beforeMount() {
      await CampaignService.listAll(false);

      const campaignCodeStr: string = this.$route.params.campaignCode + '';

      if (campaignCodeStr) {
        // find the campaign in our store for this page
        const campaignIndex: number = this.$store.getters['campaigns/campaigns'].findIndex((item: Campaign) => item.code + '' === campaignCodeStr);

        if (campaignIndex >= 0) {
          // whoop! we found our campaign
          this.thisCampaign =
            this.$store.getters['campaigns/campaigns'][campaignIndex];

          // let's go fetch our Users.
          await this.fetchUsers();
        } else {
          // we didn't find the campaign code
          this.$router.push('/');
        }
      } else {
        // GetOutaHere
        this.$router.push('/');
      }    
    }

    async fetchUsers() {
      try {
        this.isLoading = true;

        const response = await SiteUserService.listSiteUsersByCampaignId({params: { id: this.thisCampaign.id }});

        if (response && response.data) {
          if (
            (response.data.result && response.data.result === 'false') ||
            response.data.length < 1
          ) {
            // do nothing, not an error, no data was found
          } else {
            this.thisCampaign.users = response.data;
          }
        }
      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      } finally {
        this.isLoading = false;
      }
    }

    downloadReport(item: SiteUser) {
      const route = this.$router.resolve({ name: 'Report PDF', params: { id: '' + item.id} });
      window.open(route.href, '_blank');
    }
  // #endregion

  // #region Functions required for the View Results Dialog
    async viewResults(item: SiteUser) {
      this.clickedItem = Object.assign({}, item);

      // fetch results for this site user
      await this.getResultsBySiteUser();

      this.showResultsDialog = true;
    }

    async getResultsBySiteUser() {
      try {
        // check if we already have the results for this item, if you have it, do nothing
        if (!this.clickedItem.results) {
          // nope, go fetch it!

          const response = await SiteUserService.getResults({params: { id: this.clickedItem.id } });
          
          if (response && response.data) {
            if ((response.data.result && response.data.result === 'false') || response.data.length < 1) {
              // do nothing, not an error, no data was found
            } else {
              // set the results into the clicked item (user)
              this.clickedItem.results = response.data[0];
            }
          }
        }
      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      }
    }
  // #endregion

  // #region Functions required for the View Selections Dialog
    async viewSelections(item: SiteUser) {
      this.clickedItem = Object.assign({}, item);

      // fetch selections for this site user
      await this.getSelectionsBySiteUser();

      this.showSelectionsDialog = true;
    }

    async getSelectionsBySiteUser() {
      try {
        // check if we already have the selections for this item, if you have it, do nothing
        if (!this.clickedItem.selection) {
          // nope, go fetch it!
          
          const response = await SiteUserService.getSelections({ params: { id: this.clickedItem.id } });

          if (response && response.data) {
            if ((response.data.result && response.data.result === 'false') || response.data.length < 1) {
              // do nothing, not an error, no data was found
            } else {
              this.clickedItem.selection = response.data[0];
            }
          }
        }
      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }      
      }
    }
  // #endregion

  // #region Functions required for the View Subjects Dialog
    async viewSubjects(item: SiteUser) {
      this.clickedItem = Object.assign({}, item);

      // fetch subject selections for this site user
      await this.getSubjectsBySiteUser();

      this.showSubjectsDialog = true;
    }

    async getSubjectsBySiteUser() {
      try {
        // check if we already have the subjects for this item, if you have it, do nothing
        if (!this.clickedItem.subjects || this.clickedItem.subjects!.length < 1) {
          // nope, go fetch it!

          const response = await SiteUserService.getSubjects({params: { id: this.clickedItem.id } });
          
          if (response && response.data) {
            if ((response.data.result && response.data.result === 'false') || response.data.length < 1) {
              // do nothing, not an error, no data was found
            } else {
              this.clickedItem.subjects = response.data;
            }
          }
        }
      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      }
    }

  // #endregion


}
